import { Link } from 'react-router-dom';

export default function AboutHero() {
  return (
    <section aria-label="关于我们" className="relative w-full overflow-hidden bg-primary-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20dark%20navy%20blue%20cinema%20auditorium%20with%20rows%20of%20empty%20seats%20and%20a%20faint%20warm%20orange%20projector%20beam%20cutting%20through%20dusty%20air%2C%20quiet%20atmospheric%20premium%20film%20brand%20visual%2C%20soft%20volumetric%20light%2C%20large%20dark%20empty%20space%20on%20the%20left%20for%20text%2C%20no%20text&width=1600&height=700&seq=v91-about-hero&orientation=landscape"
          alt="影院放映厅背景"
          title="91在线视频 关于我们 背景"
          className="w-full h-full object-cover object-center opacity-70"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/85 to-primary-950/45" />

      <div className="relative w-full px-4 md:px-8 py-14 md:py-20">
        <nav aria-label="面包屑" className="flex items-center flex-wrap gap-1.5 text-xs text-background-200/70">
          <Link to="/" className="hover:text-accent-300 transition-colors whitespace-nowrap">首页</Link>
          <i className="ri-arrow-right-s-line text-background-200/40" />
          <span className="text-background-50 whitespace-nowrap">关于我们</span>
        </nav>

        <div className="mt-6 max-w-3xl">
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-accent-500/15 text-accent-300 text-[11px]">
            <i className="ri-book-open-line" />
            ABOUT US
          </span>
          <h1 className="mt-4 text-2xl md:text-4xl font-black text-background-50 leading-tight">
            让每一次“今晚看点什么”，都有答案
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-background-200/80">
            91在线视频是一个现代门户与卡片探索结合的影视信息平台。我们把电影、电视剧与综艺整理成清晰可筛的条目，
            让找片从翻列表变成一次有方向的浏览。当前版本为演示站点，聚焦页面结构与交互体验。
          </p>

          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/"
              className="h-10 px-5 rounded-md bg-accent-500 hover:bg-accent-600 text-primary-950 text-sm font-semibold flex items-center gap-2 whitespace-nowrap transition-colors"
            >
              <i className="ri-play-list-2-line" />
              返回首页
            </Link>
            <a
              href="#feedback"
              className="h-10 px-5 rounded-md border border-background-50/25 text-background-50 text-sm flex items-center gap-2 whitespace-nowrap hover:bg-background-50/10 transition-colors"
            >
              <i className="ri-chat-3-line" />
              提交反馈
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}